import React, { useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const waLink = (digits, text) => `https://wa.me/${digits}?text=${encodeURIComponent(text)}`;

const CURSOS_EAD = [
  {
    slug: "ead-sistemas-cultivo",
    title: "Sistemas de Cultivo da Seringueira e Produção de Látex",
    desc: "Os sistemas de cultivo da seringueira e a produção de látex, do plantio à coleta.",
    carga: "20 horas",
    duracao: "14 dias",
    url: "https://ead.senar.org.br/cursos/sistemas-de-cultivo-da-seringueira-e-producao-de-latex",
  },
  {
    slug: "ead-producao-mudas",
    title: "Produção de Mudas de Seringueira",
    desc: "Todo o processo de produção de mudas de seringueira, para viveiros e plantios.",
    carga: "10 horas",
    duracao: "10 dias",
    url: "https://ead.senar.org.br/cursos/producao-de-mudas-de-seringueira",
  },
];

export default function CursosPublicPage() {
  const [courses, setCourses] = useState(null);
  const [srcSlug, setSrcSlug] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const src = params.get("src");
    if (src) {
      setSrcSlug(src);
      localStorage.setItem("curso_src", JSON.stringify({ slug: src, ts: Date.now() }));
      axios.post(`${API}/cursos/track-visit`, { slug: src, via: params.get("via") === "qr" ? "qr" : "link" }).catch(() => {});
    }
    axios.get(`${API}/public/cursos`).then((r) => setCourses(r.data.courses || [])).catch(() => setCourses([]));
  }, []);

  const registerLink = (slug) => `/?cadastro=vaga&curso=${encodeURIComponent(slug)}`;

  return (
    <div className="min-h-screen bg-gray-50" data-testid="cursos-public-page">
      {/* HERO */}
      <section className="bg-gradient-to-b from-green-800 to-green-900 text-white py-10 px-4">
        <div className="max-w-3xl mx-auto text-center">
          <img src="/icon-192x192.png" alt="HeveaTalent" className="w-16 h-16 rounded-2xl mx-auto shadow-lg" />
          <h1 className="text-3xl md:text-4xl font-bold mt-4">🎓 Cursos Gratuitos de Sangria de Seringueira</h1>
          <p className="mt-3 text-green-100 text-sm md:text-base">
            Cursos presenciais na sua região e cursos online para começar hoje — com certificado SENAR.
            Depois, cadastre-se grátis no Balcão de Empregos para ser encontrado pelas fazendas. 100% gratuito.
          </p>
        </div>
      </section>

      <div className="max-w-3xl mx-auto px-4 py-6 space-y-5">
        {courses === null && <p className="text-center text-gray-500 py-8">Carregando cursos…</p>}

        {courses && courses.length === 0 && (
          <div className="bg-white border rounded-2xl p-6 text-center" data-testid="cursos-empty">
            <div className="text-4xl mb-2">📅</div>
            <h2 className="text-lg font-bold text-gray-800">Nenhum curso com data confirmada no momento</h2>
            <p className="text-sm text-gray-600 mt-2">
              Novos cursos do SENAR e Sindicatos Rurais são publicados aqui assim que confirmados.
            </p>
            <a href="/balcao" className="inline-block mt-4 bg-green-700 text-white px-5 py-2.5 rounded-xl text-sm font-semibold hover:bg-green-800">
              Ver vagas abertas no Balcão →
            </a>
          </div>
        )}

        {courses && courses.map((c) => (
          <div key={c.id} className="bg-white border-2 border-green-600 rounded-2xl p-5 relative shadow-sm" data-testid={`curso-card-${c.slug}`}>
            <span className={`absolute -top-3 left-5 px-3 py-0.5 rounded-full text-xs font-bold text-white ${c.situacao === "inscricoes_abertas" ? "bg-green-600" : "bg-amber-600"}`}>
              {c.situacao === "inscricoes_abertas" ? "📍 CONFIRMADO — INSCRIÇÕES ABERTAS" : "⏳ EM ANDAMENTO"}
            </span>
            <h2 className="text-xl font-bold text-gray-900 mt-2">
              {c.title} — {c.city}{c.uf ? `/${c.uf}` : ""}
            </h2>
            <div className="grid sm:grid-cols-2 gap-x-4 gap-y-1.5 mt-3 text-sm text-gray-700">
              <div>📅 <b>Data:</b> {c.dates_label}</div>
              <div>⏰ <b>Horário:</b> {c.horario}</div>
              {c.local && <div>📌 <b>Local:</b> {c.local}</div>}
              <div>⏱️ <b>Carga:</b> {c.carga_horaria}</div>
              <div>🎓 <b>Certificado:</b> {c.certificado}</div>
              {c.vagas ? <div>👥 <b>Vagas:</b> {c.vagas} — {c.valor}</div> : <div>💰 <b>Valor:</b> {c.valor}</div>}
              <div className="sm:col-span-2">📚 <b>Aprenda:</b> {c.conteudo}</div>
              <div>✅ <b>Pré-requisito:</b> {c.prerequisito}</div>
              {c.extra_info && <div className="sm:col-span-2">ℹ️ {c.extra_info}</div>}
            </div>
            <div className="mt-4 flex flex-col sm:flex-row gap-2.5">
              {c.wa_digits && (
                <a
                  href={waLink(c.wa_digits, `Olá! Quero me inscrever no curso de sangria de ${c.dates_label} em ${c.city}. Vi na HeveaTalent.`)}
                  target="_blank" rel="noreferrer"
                  className="bg-green-600 text-white px-5 py-3 rounded-xl font-bold text-center text-sm hover:bg-green-700"
                  data-testid={`curso-inscrever-${c.slug}`}
                >
                  QUERO ME INSCREVER — WhatsApp
                </a>
              )}
              <a
                href={`/vagas/${c.city_slug}`}
                className="border-2 border-green-600 text-green-700 px-5 py-3 rounded-xl font-bold text-center text-sm hover:bg-green-50"
                data-testid={`curso-vagas-${c.slug}`}
              >
                Ver vagas em {c.city}{c.jobs_in_city > 0 ? ` (${c.jobs_in_city} aberta${c.jobs_in_city !== 1 ? "s" : ""})` : ""} →
              </a>
            </div>
            <a href={registerLink(c.slug)} className="block mt-3 text-center text-xs text-gray-500 underline" data-testid={`curso-ja-fiz-${c.slug}`}>
              Já fiz este curso — quero me cadastrar no Balcão 🎓
            </a>
          </div>
        ))}

        {/* CURSOS ONLINE EAD SENAR — sempre disponíveis */}
        <div data-testid="cursos-ead-section">
          <div className="text-center mt-8 mb-4">
            <h2 className="text-xl md:text-2xl font-bold text-gray-900">💻 Cursos Online Gratuitos — EAD SENAR</h2>
            <p className="text-sm text-gray-600 mt-1">
              Estude de casa, pelo celular, no seu ritmo. 100% online, com certificado e <b>início imediato</b> — não precisa esperar turma.
            </p>
          </div>
          <div className="space-y-4">
            {CURSOS_EAD.map((c) => (
              <div key={c.slug} className="bg-white border-2 border-sky-500 rounded-2xl p-5 relative shadow-sm" data-testid={`curso-ead-${c.slug}`}>
                <span className="absolute -top-3 left-5 px-3 py-0.5 rounded-full text-xs font-bold text-white bg-sky-600">
                  💻 ONLINE — COMECE HOJE
                </span>
                <h3 className="text-lg font-bold text-gray-900 mt-2">{c.title}</h3>
                <p className="text-sm text-gray-600 mt-1">{c.desc}</p>
                <div className="grid sm:grid-cols-2 gap-x-4 gap-y-1.5 mt-3 text-sm text-gray-700">
                  <div>⏱️ <b>Carga:</b> {c.carga}</div>
                  <div>📆 <b>Duração:</b> até {c.duracao}</div>
                  <div>🎓 <b>Certificado:</b> Sim — SENAR</div>
                  <div>💰 <b>Valor:</b> Gratuito</div>
                  <div className="sm:col-span-2">✅ <b>Pré-requisito:</b> Maior de 18 anos — aulas em vídeo pelo site ou app Senar Play</div>
                </div>
                <div className="mt-4 flex flex-col sm:flex-row gap-2.5">
                  <a
                    href={c.url}
                    target="_blank" rel="noreferrer"
                    className="bg-sky-600 text-white px-5 py-3 rounded-xl font-bold text-center text-sm hover:bg-sky-700"
                    data-testid={`curso-ead-matricular-${c.slug}`}
                  >
                    MATRICULAR GRÁTIS NO SENAR →
                  </a>
                  <a
                    href={`https://wa.me/?text=${encodeURIComponent(`🎓 Curso GRATUITO e online do SENAR: *${c.title}* (${c.carga}, com certificado). Comece hoje: ${c.url}\n\nDepois do curso, cadastre-se grátis no Balcão de Empregos: heveatalent.com.br/balcao 🌳`)}`}
                    target="_blank" rel="noreferrer"
                    className="border-2 border-sky-600 text-sky-700 px-5 py-3 rounded-xl font-bold text-center text-sm hover:bg-sky-50"
                    data-testid={`curso-ead-compartilhar-${c.slug}`}
                  >
                    📲 Indicar para alguém
                  </a>
                </div>
                <p className="mt-3 text-center text-xs text-gray-500">
                  Terminou o curso? <a href={registerLink(c.slug)} className="underline font-semibold">Cadastre-se no Balcão e seja encontrado pelas fazendas 🎓</a>
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA FINAL — fecha o elo */}
        <div className="bg-gray-900 text-white rounded-2xl p-6 text-center" data-testid="cursos-cta-final">
          <h2 className="text-2xl font-bold text-white">Já fez o curso de sangria?</h2>
          <p className="mt-2 text-gray-300 text-sm">
            Cadastre-se no Balcão da HeveaTalent e seja encontrado por fazendas da sua cidade. É grátis e leva 2 minutos.
          </p>
          <a
            href={registerLink(srcSlug || (courses && courses[0]?.slug) || "")}
            className="mt-4 inline-block bg-green-500 text-gray-900 px-7 py-3.5 rounded-xl font-black text-base hover:bg-green-400"
            data-testid="cursos-register-cta"
          >
            CADASTRAR COMO SANGRADOR →
          </a>
          <p className="mt-3 text-xs text-gray-400">heveatalent.com.br/balcao</p>
        </div>

        {/* PARCEIROS */}
        <div className="bg-green-50 border border-green-200 rounded-2xl p-4 text-center text-sm" data-testid="cursos-parceiros-cta">
          <p className="text-green-900 font-semibold">É sindicato, SENAR ou instrutor?</p>
          <p className="text-green-800 mt-1">Divulgamos seu curso de graça e ajudamos seus alunos a conseguirem emprego.</p>
          <a href="/parceiros" className="inline-block mt-2 underline font-bold text-green-700">Cadastre seu curso aqui →</a>
        </div>

        {/* SEO footer */}
        <p className="text-[11px] text-gray-400 leading-relaxed pb-6">
          Encontre cursos gratuitos de sangrador de seringueira oferecidos pelo SENAR, Sindicatos Rurais e Casas da
          Agricultura. Cursos de 24 horas com certificado e aulas práticas. Após o curso, cadastre-se no balcão de
          empregos HeveaTalent e seja encontrado por fazendas que contratam sangradores.
          {" "}<a href="/vagas" className="underline">Vagas por cidade</a> · <a href="/balcao" className="underline">Balcão de Empregos</a>
        </p>
      </div>
    </div>
  );
}
